export const hasEmptyInputs = (inputComponents) => {
  const filter = inputComponents.filter((input) => input.props.value === null || input.props.value === '')
  return filter.length > 0
}
